import type { QueryClient } from "@tanstack/vue-query";

import { bidQueryKeys } from "~/queries/catalog/bids";
import { followedCategoriesListQueryKeys } from "~/queries/catalog/mePreferenceCategories";
import { followedEventsListQueryKeys } from "~/queries/catalog/mePreferenceEvents";
import { followedProductsListQueryKeys } from "~/queries/catalog/mePreferenceProducts";
import { preferencesQueryKeys } from "~/queries/catalog/preferences";
import { customerQueryKeys } from "~/queries/finance/customers";
import { meQueryKeys } from "~/queries/identity/me";

export default (queryClient: QueryClient) => {
  queryClient.resetQueries({ queryKey: meQueryKeys._def });
  queryClient.resetQueries({
    queryKey: customerQueryKeys.currentDetails._def,
  });
  queryClient.resetQueries({ queryKey: followedCategoriesListQueryKeys._def });
  queryClient.resetQueries({ queryKey: followedEventsListQueryKeys._def });
  queryClient.resetQueries({ queryKey: followedProductsListQueryKeys._def });
  queryClient.resetQueries({ queryKey: preferencesQueryKeys._def });
  queryClient.resetQueries({ queryKey: bidQueryKeys._def });
};
